import { render, staticRenderFns } from "./ContractTab.vue?vue&type=template&id=706c2658&scoped=true&"
import script from "./ContractTab.vue?vue&type=script&lang=js&"
export * from "./ContractTab.vue?vue&type=script&lang=js&"
import style0 from "./ContractTab.vue?vue&type=style&index=0&id=706c2658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706c2658",
  null
  
)

export default component.exports